import React from 'react';
import Lottie from 'react-lottie';
import i18next from 'i18next';
import { useSelector } from 'react-redux';

import { getLottieOptions } from '~utils/lottie';
import uniqueLoading from '~assets/lotties/unique-loading.json';
import CreditEndingStatus from '~app/components/CreditEndingStatus';
import SimulationLoadingWrapper from '~app/components/SimulationLoadingWrapper';
import { useFlowChoice } from '~app/hooks/useFlowChoice';
import { INCUMBENT_TYPES } from '~constants/incumbent';
import { getStepNameByFlowChoice } from '~screens/ClientFlowChoice/utils';

import styles from './styles.module.scss';

export default function EvaluationPending() {
  const { changeIncumbentLoading, clientFlowChoice, clientFinancialInfo } = useSelector(
    state => state.simulation
  );
  const { handleManualChoice } = useFlowChoice({
    incumbent: INCUMBENT_TYPES.CLIENT,
    currentFlowChoice: clientFlowChoice,
    getStepNameByFlowChoice: getStepNameByFlowChoice(clientFinancialInfo)
  });
  const evaluationAnim = () => (
    <div className={styles.salesContainer}>
      <Lottie
        options={getLottieOptions({
          loop: true,
          autoplay: true,
          animationData: uniqueLoading
        })}
      />
    </div>
  );
  return (
    <SimulationLoadingWrapper>
      <CreditEndingStatus
        title={i18next.t('EvaluationPending:title')}
        info={i18next.t('EvaluationPending:info')}
        summaryButton={i18next.t('EvaluationPending:summaryButton')}
        Image={evaluationAnim}
        loading={changeIncumbentLoading}
        handleCheckout={handleManualChoice}
      />
    </SimulationLoadingWrapper>
  );
}
